// AUTOGENERATED
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dAnalytics$dTypes$dPage from "../Restaumatic.Analytics.Types.Page/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
const pageIsSymbol = {reflectSymbol: () => "page"};
const ChooseTakeawayIsSymbol = {reflectSymbol: () => "ChooseTakeaway"};
const ChooseTakeaway = x => x;
const toFillFormTypeChooseTakea = {fillFormDataType: v => "unknown"};
const newtypeChooseTakeaway_ = {Coercible0: () => {}};
const hasFieldChooseTakeaway = dictHasField => dictHasField;
const eqChooseTakeaway = {eq: x => y => Restaumatic$dAnalytics$dTypes$dPage.eqPage.eq(x.page)(y.page)};
const genericChooseTakeaway = {to: x => x, from: x => x};
const showChooseTakeaway = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ page: " + Restaumatic$dAnalytics$dTypes$dPage.showPage.show(v.page) + " }"]})(ChooseTakeawayIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeChooseTakeaway = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(pageIsSymbol)(Restaumatic$dAnalytics$dTypes$dPage.unscrambleDecodePage)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeChooseTakeaway = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericChooseTakeaway)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ChooseTakeawayIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(pageIsSymbol)({
      encodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dPage.encodePage.encode
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeChooseTakeaway = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericChooseTakeaway)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ChooseTakeawayIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(pageIsSymbol)({
    decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dPage.decodePage.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  ChooseTakeaway,
  ChooseTakeawayIsSymbol,
  decodeChooseTakeaway,
  encodeChooseTakeaway,
  eqChooseTakeaway,
  genericChooseTakeaway,
  hasFieldChooseTakeaway,
  newtypeChooseTakeaway_,
  pageIsSymbol,
  showChooseTakeaway,
  toFillFormTypeChooseTakea,
  unscrambleDecodeChooseTakeaway
};
